<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Universities</h4>
          <div class="md-card-header-icon md-card-header-green text-right">
            <md-button
              v-if="$store.role === 1"
              @click="goToCreate"
              class="md-success"
            >
              CREATE UNIVERSITY
            </md-button>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select
                  v-model="pagination.perPage"
                  name="pages"
                  @md-selected="customSort"
                >
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <div>
                <md-button
                  style="margin-left: 10px"
                  @click="filterPanel"
                  class="md-info"
                >
                  Filters
                </md-button>
                <md-button
                  style="margin-left: 10px"
                  @click="clearFilters"
                  class="md-primary md-just-icon md-round"
                >
                  <md-icon>delete_sweep</md-icon>
                  <md-tooltip md-direction="bottom">Clear Filters</md-tooltip>
                </md-button>
              </div>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name" md-sort-by="name"
                >{{ item.name }}
              </md-table-cell>
              <md-table-cell md-label="Type" md-sort-by="type"
                >{{ item.type }}
              </md-table-cell>
              <md-table-cell md-label="Country"
                >{{ item.city.country.name }}
              </md-table-cell>
              <md-table-cell md-label="City">{{
                item.city.name
              }}</md-table-cell>
              <md-table-cell md-label="Contract" md-sort-by="contract"
                >{{ item.contract }}
              </md-table-cell>
              <md-table-cell md-label="Status">{{ item.status }}</md-table-cell>
              <md-table-cell md-label="Website">{{
                item.website
              }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  style="margin-right: 14px;"
                  class="md-just-icon md-warning md-round"
                  @click.native="handleEdit(item)"
                  v-if="$store.role === 1 || $store.role === 4"
                >
                  <md-icon>create</md-icon>
                  <md-tooltip md-direction="bottom">Edit</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        {{ item }}
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @page="updatePage"
          >
          </pagination>
        </md-card-actions>
      </md-card>

      <md-dialog :md-active.sync="showFilters" class="filterPanelClass">
        <md-dialog-title>Filters</md-dialog-title>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>City</label>
            <md-select v-model="city" name="city">
              <md-option value="">Select City</md-option>
              <md-option v-for="c in cities" v-bind:key="c.id" :value="c.id">
                {{ c.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>account_balance</md-icon>
            <label>University Name</label>
            <md-input v-model="name" type="text"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>Type</label>
            <md-select v-model="type" name="type">
              <md-option value="">Select Type</md-option>
              <md-option value="2">Private</md-option>
              <md-option value="1">State</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>Contract</label>
            <md-select v-model="contract" name="contract">
              <md-option value="">Select Contract</md-option>
              <md-option value="true">True</md-option>
              <md-option value="false">False</md-option>
            </md-select>
          </md-field>
        </div>

        <md-dialog-actions>
          <md-button class="md-danger" @click="showFilters = false"
            >Close</md-button
          >
          <md-button class="md-success" @click="addFilter">Filter</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    getParams() {
      return {
        ordering: this.getSortingKey(),
        limit: this.pagination.perPage,
        offset: this.from,
        ...this.searchQuery
      };
    }
  },
  data() {
    return {
      currentSort: "id",
      currentSortOrder: "desc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30],
        total: 0
      },
      footerTable: [
        "Name",
        "Type",
        "Country",
        "City",
        "Contract",
        "Status",
        "Website",
        "Actions"
      ],
      searchQuery: {},
      propsToSearch: ["id", "name", "type", "contract"],
      tableData: [],
      searchedData: [],
      first: true,

      table_spinner: true,
      showFilters: false,

      cities: null,
      name: null,
      type: null,
      city: null,
      contract: null
    };
  },
  methods: {
    goToCreate: function() {
      this.$router.push({ name: "University Create" });
    },
    filterPanel: function() {
      this.showFilters = true;
      if (this.cities) {
        return;
      }
      this.$store
        .getCities()
        .then(response => {
          this.cities = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    clearFilters: function() {
      this.searchQuery = {};
      this.name = null;
      this.type = null;
      this.city = null;
      this.contract = null;
      this.pagination.currentPage = 1;
      this.getUniversities();
    },
    addFilter: function() {
      let origin_params = {};
      let params = {
        city: this.city,
        name: this.name,
        type: this.type,
        contract: this.contract
      };
      for (const field in params) {
        if (
          params[field] === null ||
          params[field] === undefined ||
          params[field] === ""
        ) {
          continue;
        }
        origin_params[field] = params[field];
      }
      this.searchQuery = origin_params;
      this.pagination.currentPage = 1;
      this.getUniversities();
      this.showFilters = false;
    },
    customSort(value) {
      if (this.first) {
        this.first = false;
        this.checkQueryParam();
      } else {
        this.pagination.currentPage = 1;
      }
      this.getUniversities();
    },
    getSortingKey() {
      var key = this.currentSort;
      if (this.currentSortOrder === "desc") {
        key = "-" + this.currentSort;
      }
      return key;
    },
    handleEdit(item) {
      this.$router.push({ name: "University Update", params: { id: item.id } });
    },
    getUniversities() {
      this.tableData = [];
      this.table_spinner = true;
      var params = this.getParams;
      this.$store
        .getUniversities(params)
        .then(response => {
          this.tableData = response.data.results;
          this.pagination.total = response.data.count;
          if (params.offset) {
            this.pagination.currentPage = this.getCurrentPage(params.offset);
          }
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: JSON.stringify(error.response.data),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    updatePage(page) {
      this.getUniversities();
    },
    getCurrentPage(offset) {
      return offset / this.pagination.perPage + 1;
    },
    checkQueryParam() {
      if (window.location.search !== "") {
        var params = window.location.search
          .slice(1)
          .split("&")
          .map(p => p.split("="))
          .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (params.ordering) {
          if (params.ordering[0] === "-") {
            this.currentSortOrder = "desc";
            params.ordering = params.ordering.replace("-", "");
          } else {
            this.currentSortOrder = "asc";
          }
          this.currentSort = params.ordering;
          delete params.ordering;
        }
        if (params.limit) {
          this.pagination.perPage = parseInt(params.limit);
          delete params.limit;
        }
        if (params.offset) {
          this.pagination.currentPage = this.getCurrentPage(params.offset);
          delete params.offset;
        }
        this.searchQuery = params;
      }
    }
  },
  watch: {
    searchQuery(query) {
      let params = this.getParams;
      let query_param = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      window.history.replaceState(
        "page",
        "Title",
        window.location.pathname + "?" + query_param
      );
    },
    pagination: {
      deep: true,
      handler(val) {
        let params = this.getParams;
        let query_param = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
        window.history.replaceState(
          "page",
          "Title",
          window.location.pathname + "?" + query_param
        );
      }
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>

<style>
body > div.md-dialog.filterPanelClass > div {
  overflow: auto;
}
</style>
